'use client';

import posthog from 'posthog-js';

type TelemetryValue = string | number | boolean | null | undefined;
type TelemetryProperties = Record<string, TelemetryValue>;

function compactProperties(properties: TelemetryProperties): Record<string, string | number | boolean | null> {
  return Object.fromEntries(
    Object.entries(properties).filter(([, value]) => value !== undefined)
  ) as Record<string, string | number | boolean | null>;
}

export function captureProductTelemetry(
  eventName: string,
  properties: TelemetryProperties = {},
) {
  if (typeof window === 'undefined') return;

  try {
    posthog.capture(eventName, compactProperties(properties));
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[Telemetry] Failed to capture event', eventName, error);
    }
  }
}
